import { Box, Flex, useDisclosure } from "@chakra-ui/react";
import Header from "./Header";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Flex direction="column" h="100vh" overflow="hidden">
      <Box position="fixed" top="0" left="0" width="100%" zIndex="10">
        <Header onToggleSidebar={onToggle} />
      </Box>

      <Flex flex="1" pt="60px">
        <Sidebar isOpen={isOpen} onClose={onToggle} />

        <Box
          flex="1"
          padding={8}
          overflowY="auto"
          height="calc(100vh - 60px)"
        >
          <Box maxWidth="1100px" margin="auto" padding={8}>
            {children}
          </Box>
        </Box>
      </Flex>
    </Flex>
  );
};

export default Layout;
